import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle'

export default class extends Controller {
    static values = { options: Object }
    static targets = ["swiperContainer", "nextButton", "prevButton", "pagination"]

    connect() {
        const options = {
            ...this.optionsValue,
            navigation: {
                nextEl: this.nextButtonTarget,
                prevEl: this.prevButtonTarget
            },
            pagination: this.hasPaginationTarget ? {
                el: this.paginationTarget,
                clickable: true
            } : false,

            // any other options you want to set
        }

        this.swiper = new Swiper(this.swiperContainerTarget, options)
    }

    disconnect() {
        if (this.swiper) {
            this.swiper.destroy()
            this.swiper = undefined
        }
    }
}
